export default "__VITE_ASSET__DV$47sUQ__"